import template from './aside-menu.pug';
import controller from './aside-menu.controller';

const AsideMenuComponent = {
  template,
  controller,
};

export default AsideMenuComponent;



// WEBPACK FOOTER //
// ./client/components/aside-menu/aside-menu.component.js